<div *ngIf="dataIsLoaded">

  <div class="be-block" *ngFor="let item of data; index as i;" (deferLoad)="lazyLoad[0]=true">

    <div class="text-center container">
      <h2 [innerHTML]="item.heading"></h2>
      <p [innerHTML]="item.subheading"></p>
      <p class="be-block-text" [innerHTML]="item.text"></p>
    </div>

    <div class="row no-gutters be-block-images-container"
         [ngClass]="{'container':!item.image1||!item.image2,'one-image-left':!item.image2,'one-image-right':!item.image1}">
      <div class="col-12 col-md-6"><img *ngIf="item.image1 && lazyLoad[0]" [src]="item.image1" class="w-100"/></div>
      <div class="col-12 col-md-6"><img *ngIf="item.image2 && lazyLoad[0]" [src]="item.image2" class="w-100"/></div>
      <!-- change in China -->
      <div class="be-quote-container">
        <div class="be-block-quote text-center">
          <p class="mb-4 quote-text" [innerHTML]="'&ldquo;'+item.quoteText+'&rdquo;'"></p>
          <div class="row d-flex align-items-center">
            <ng-container *ngIf="isBaoying() && i !== 0">
              <div class="col-12 col-md-12 text-md-right">
                <small [innerHTML]="item.quoteTitle"></small>
              </div>
            </ng-container>
            <ng-container *ngIf="!isBaoying()">
              <div class="col-12 col-md-5 text-md-right mb-3 mb-md-0">
                <img [src]="item.quoteImage" *ngIf="lazyLoad[0]" alt=""/>
              </div>
              <div class="col-12 col-md-7 text-md-left">
                <p class="mb-1"><strong [innerHTML]="item.quoteAuthor"></strong></p>
                <small [innerHTML]="item.quoteTitle"></small>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
